import { useWindowScroll } from 'react-use';
import { Banner } from 'ui/banner';
import { BannerVariants } from 'ui/banner/types';
import { ShrinkingButton } from 'ui/button/ShrinkingButton';
import { FlexSpacer } from 'ui/flexSpacer';
import { WarningFill16 } from 'ui/icons';
import { PageHeader } from 'ui/pageHeader';
import { PAGE_HEADER_VARIANTS } from 'ui/pageHeader/constants';
import { useNavBarHeight } from 'utils/hooks/useNavBarHeight';
import { useProjectSettingsQueryContext } from '../contexts';
import { useSubmitProjectSettings } from '../hooks/useSubmitProjectSettings';
import { PageActionsContainer, PageHeading } from './ProjectSettingsPage.styled';
import { ProjectSettingsSubheading } from './ProjectSettingsSubheading';

export const DISPLAY_TEXT = {
  PAGE_HEADER: 'Settings',
  SAVE_BUTTON: 'Save',
};

export const ProjectSettingsPageHeader = () => {
  const { onSubmit, isDirty, isLoading } = useSubmitProjectSettings();
  const { project, organization } = useProjectSettingsQueryContext();
  const { y: scrollY } = useWindowScroll();
  const navBarHeight = useNavBarHeight();
  const isPastScrollBreakpoint = scrollY > 0;

  return (
    <PageHeader
      data-test="project-settings-page-header"
      documentTitle="Settings"
      hasNormalPageWidth
      isPastScrollBreakpoint={isPastScrollBreakpoint}
      isSticky
      navBarHeight={navBarHeight}
      pageActions={
        <PageActionsContainer>
          {isDirty && (
            <FlexSpacer>
              <Banner Icon={<WarningFill16 />} isSubtle variant={BannerVariants.WARNING}>
                There are unsaved changes
              </Banner>
            </FlexSpacer>
          )}

          <ShrinkingButton
            data-test="project-settings-save-button"
            onClick={onSubmit}
            isLoading={isLoading}
          >
            {DISPLAY_TEXT.SAVE_BUTTON}
          </ShrinkingButton>
        </PageActionsContainer>
      }
      pageSubSection={<ProjectSettingsSubheading organization={organization} project={project} />}
      variant={PAGE_HEADER_VARIANTS.TERTIARY}
    >
      <PageHeading>{DISPLAY_TEXT.PAGE_HEADER}</PageHeading>
    </PageHeader>
  );
};
